import { render, staticRenderFns } from "./InformeGlobalIncidencias.vue?vue&type=template&id=8b41833c&"
import script from "./InformeGlobalIncidencias.vue?vue&type=script&lang=js&"
export * from "./InformeGlobalIncidencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports